import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { api, API } from "@/lib/api";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

export default function GallerySection() {
  const [photos, setPhotos] = useState([]);
  const [viewing, setViewing] = useState(null);

  useEffect(() => {
    api.get("/gallery").then((r) => setPhotos(r.data)).catch(() => {});
  }, []);

  if (photos.length === 0) return null;

  return (
    <section id="galeria" data-testid="gallery-section" className="px-4 sm:px-8 lg:px-16 py-20 lg:py-32">
      <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}>
        <motion.p variants={fadeUp} className="overline-label text-[#4A0E17]/60">Galeria de Fotos</motion.p>
        <motion.h2 variants={fadeUp} className="font-display mt-4 max-w-3xl text-4xl sm:text-5xl font-bold uppercase leading-tight text-[#1C1917]">
          Celebrações da nossa Diocese
        </motion.h2>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {photos.map((p, i) => (
            <motion.button
              key={p.id}
              variants={fadeUp}
              data-testid={`gallery-photo-${i}`}
              onClick={() => setViewing(p)}
              className="group relative overflow-hidden border border-[#E5DEC9]"
            >
              <img
                src={`${API}/files/${p.storage_path}`}
                alt={p.titulo || "Celebração da Diocese Anglicana Católica do Brasil"}
                loading="lazy"
                className="aspect-[4/5] w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              {p.titulo && (
                <span className="absolute inset-x-0 bottom-0 bg-[#2E070D]/80 px-4 py-2.5 text-left font-liturgy text-base italic text-[#FBF9F4] opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  {p.titulo}
                </span>
              )}
            </motion.button>
          ))}
        </div>
      </motion.div>

      <AnimatePresence>
        {viewing && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] flex items-center justify-center bg-[#140709]/95 backdrop-blur-sm p-4"
            onClick={() => setViewing(null)}
          >
            <motion.figure
              data-testid="gallery-lightbox"
              initial={{ opacity: 0, scale: 0.96 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.96 }}
              transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
              className="relative max-h-[88vh] max-w-4xl"
              onClick={(e) => e.stopPropagation()}
            >
              <button data-testid="gallery-lightbox-close" onClick={() => setViewing(null)} aria-label="Fechar" className="absolute -top-3 -right-3 z-10 bg-[#C5A059] p-2 text-[#2E070D] hover:bg-[#D4AF37] transition-colors">
                <X className="h-5 w-5" />
              </button>
              <img src={`${API}/files/${viewing.storage_path}`} alt={viewing.titulo || "Celebração da DACB"} className="max-h-[80vh] w-auto object-contain border border-[#C5A059]/30" />
              {viewing.titulo && <figcaption className="mt-4 text-center font-liturgy text-xl italic text-[#FBF9F4]/85">{viewing.titulo}</figcaption>}
            </motion.figure>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
